import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div(
  ({theme}) => css`
    color: ${theme.colors.backgroundPrimary};
    border-radius: 50%;
    transition: background-color 300ms;

    svg {
      display: block;
      filter: drop-shadow(0px 1px 1px ${theme.colors.backgroundOverlay});
    }
  `
);
